import { useTranslation } from "react-i18next";
import Level from "./Level";
import { useUserStore } from "@/modules/auth/store/user";
import Skeleton from "@/components/common/Skeleton";
import { Icon } from "@/components/common/icon/Icon";

const Levels = () => {
  const { t } = useTranslation();
  const { network, isNetworkLoading } = useUserStore();

  const levels = network?.levels || [];

  return (
    <div className="flex w-full flex-col pb-6">
      <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
        {t("network-page.level_statistics")}
      </p>
      <div className="w-full flex flex-col py-0.5 bg-bg rounded-[0.75rem]">
        {isNetworkLoading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="w-full flex items-center justify-between gap-4 px-4"
              >
                <div className="flex flex-col gap-0.5 py-3">
                  <div className="flex items-center gap-1">
                    <Skeleton className="w-10 h-5.5" />

                    <Icon type="lock" className="fill-skeleton-dark w-5 h-5" />
                  </div>

                  <Skeleton className="w-5 h-5" />

                  <Skeleton className="w-20 h-4" />
                </div>

                <div className="shrink-0 flex flex-col items-end gap-0.5">
                  <Skeleton className="w-8 h-5.5" />

                  <Skeleton className="w-25 h-5" />

                  <Skeleton className="w-15 h-5" />
                </div>
              </div>
            ))
          : levels.map((levelData, idx) => (
              <div key={idx}>
                <Level
                  level={levelData.level}
                  rewardPercent={levelData.rewardPercent}
                  personalActiveVolumeUsd={
                    levelData.need.personalActiveVolumeUsd
                  }
                  referralsHistoricalVolumeUsd={
                    levelData.need.referralsHistoricalVolumeUsd
                  }
                  usdt={levelData.usdt}
                  referralsNumber={levelData.referralsNumber}
                  allReferralsNumber={levelData.allReferralsNumber}
                  locked={levelData.locked}
                />

                {idx !== levels.length - 1 && (
                  <div className="w-full pl-18">
                    <div className="w-full h-px bg-divider"></div>
                  </div>
                )}
              </div>
            ))}
      </div>
    </div>
  );
};

export default Levels;
